export default function copyToClipboard(value) {
  const copyhelper = document.createElement('input');
  copyhelper.style.cssText = 'opacity: 0';
  document.body.appendChild(copyhelper);
  copyhelper.value = value;
  copyhelper.select();
  document.execCommand('copy');
  document.body.removeChild(copyhelper);
}
